export const NAVIGATION_STICKYSLEVEL_MAIN = "main";
export const NAVIGATION_STICKYSLEVEL_TOOLBAR = "toolbar";
export const NAVIGATION_STICKYSLEVEL_META = "meta";

export const NAVIGATION_STICKYLEVELS = [
  NAVIGATION_STICKYSLEVEL_MAIN,
  NAVIGATION_STICKYSLEVEL_TOOLBAR,
  NAVIGATION_STICKYSLEVEL_META
] as const;
